// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__j-CJr","logo":"Layout_logo__XRSB9","background":"Layout_background__KVqE3"};